// extracted by mini-css-extract-plugin
export default {"component":"SectionContent_component__OU40p"};